// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"cc439677","202":"70bc92de","394":"218b2ade","453":"ed3810f9","493":"e5be8f72","617":"0ff3b1aa","657":"eb57f24b"}[chunkId] + ".chunk.js";
};